import type { ReactNode } from 'react';

interface RevealProps {
  children: ReactNode;
  delay?: number;
}

export function Reveal({ children, delay = 0 }: RevealProps) {
  return (
    <div
      className="card-appear card-appear-active"
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}
